import { useEffect } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import ProfileSidebar from "~/components/profile-sidebar";
import Layout from "~/Layout";
import { useGetTenantsId } from "~/api/generated/api";
import { getName } from "country-list";
import ReactCountryFlag from "react-country-flag";
import { Skeleton } from "primereact/skeleton";
import { useAccountManager } from "./useAccountManager";
import ToastMessage from "~/components/ToastMessage";

const AccountManagerProfile = () => {
  const navigate = useNavigate();
  const { id, managerId } = useParams();
  const { data: tenantResponse } = useGetTenantsId(id!);
  const tenant = tenantResponse?.data?.data;
  const {
    fetchAccountManagerDetails,
    accountManagerInfo,
    handleSave,
    toastRef,
    isEditing,
    setIsEditing,
    isLoading,
    isDetailsLoading,
    fetchManagedEntities,
  } = useAccountManager();

  const TABS = [
    {
      label: "Personal Information",
      link: `/tenants/${id}/account-manager/${managerId}`,
      code: "info",
    },
    {
      label: "Managed Entities",
      link: `/tenants/${id}/account-manager/${managerId}/managed-entities`,
      code: "managed-entities",
    },
  ];
  const segments = location.pathname.split("/");
  const activeTab = segments[segments.length - 1] || "info";

  const getTenantBreadcrumb = () => {
    if (!tenant) return;
    const countryName = tenant.country ? getName(tenant.country) : "";
    const countryFlag = tenant.country && (
      <ReactCountryFlag countryCode={tenant.country} svg />
    );
    return (
      <span className="flex gap-1 link__style pointer">
        {tenant.tenant_name}({countryFlag}
        {countryName})
      </span>
    );
  };

  const breadcrumbs = [
    {
      label: <span className="link__style flex pointer">Tenants</span>,
      command: () => navigate("/tenants"),
    },
    {
      label: tenant ? (
        getTenantBreadcrumb()
      ) : (
        <Skeleton width="100px" height="20px" className="mr-1" />
      ),
      command: () => navigate(`/tenants/${id}`),
    },
    {
      label: "Account Manager",
    },
  ];

  useEffect(() => {
    fetchAccountManagerDetails();
  }, [managerId]);

  return (
    <Layout crumbs={breadcrumbs}>
      <div className="grid">
        <div className="col-3">
          {/* Profile section */}
          <ProfileSidebar
            profileDetails={accountManagerInfo}
            title="Account Manager"
            isLoading={isDetailsLoading}
            activeTab={activeTab}
            tabs={TABS}
          />
        </div>
        <div className="col-9">
          {/*Profile detail section/ outlet */}
          <Outlet
            context={{
              accountManagerInfo,
              handleSave,
              toastRef,
              isEditing,
              setIsEditing,
              isLoading,
              fetchManagedEntities,
              managerId,
            }}
          />
        </div>
        <ToastMessage ref={toastRef} />
      </div>
    </Layout>
  );
};

export default AccountManagerProfile;
